import { useLingui } from '@lingui/react/macro';

import InputSearch from '@/design_system/InputSearch';

export const InvoiceLineSearch = ({
  search,
  debouncedSetSearch,
}: {
  search: string;
  debouncedSetSearch: (value: string) => void;
}) => {
  const { t } = useLingui();

  return (
    <InputSearch
      placeholder={t({
        id: 'accounting.invoice-lines.search.placeholder',
        message: 'Search services...',
      })}
      ariaLabel={t({
        id: 'accounting.invoice-lines.search.placeholder',
        message: 'Search services...',
      })}
      style={{ flex: 1, minWidth: '250px', maxWidth: '400px' }}
      value={search}
      onChange={debouncedSetSearch}
      size="medium"
    />
  );
};
